import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Row,
  Col,
} from "reactstrap";
import axios from "../../../utills/api";

const EditReservationModal = ({
  isOpen,
  toggle,
  booking,
  onUpdated,
}) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (booking) {
      setForm({
        address: booking.address || "",
        roomType: booking.roomType || "",
        assignedRoom: booking.assignedRoom?._id || "",
        checkIn: booking.checkIn || "",
        checkOut: booking.checkOut || "",
        adults: booking.adults || 0,
        children: booking.children || 0,
        numberOfGuests: booking.numberOfGuests || 0,
      });
    }
  }, [booking]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
  try {
    const res = await axios.put(
      `/bookings/${booking._id}/update`,
      form
    );

    console.log("UPDATED:", res.data);

    onUpdated?.(res.data.booking);
    toggle();
  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};
const isInvalid =
  new Date(form.checkOut) <= new Date(form.checkIn);

  if (!booking) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Edit Reservation
      </ModalHeader>

      <ModalBody>
        <Row className="g-3">

          <Col md={6}>
            <label>Address</label>
            <Input
              name="address"
              value={form.address}
              onChange={handleChange}
            />
          </Col>

          <Col md={6}>
            <label>Room Type</label>
            <Input
              name="roomType"
              value={form.roomType}
              onChange={handleChange}
            />
          </Col>

          <Col md={6}>
            <label>Check In</label>
            <Input
              type="datetime-local"
              name="checkIn"
              value={form.checkIn}
              onChange={handleChange}
            />
          </Col>

          <Col md={6}>
            <label>Check Out</label>
            <Input
              type="datetime-local"
              name="checkOut"
              value={form.checkOut}
              onChange={handleChange}
            />
          </Col>

          <Col md={4}>
            <label>Adults</label>
            <Input
              type="number"
              name="adults"
              value={form.adults}
              onChange={handleChange}
            />
          </Col>

          <Col md={4}>
            <label>Children</label>
            <Input
              type="number"
              name="children"
              value={form.children}
              onChange={handleChange}
            />
          </Col>

          <Col md={4}>
            <label>Guests</label>
            <Input
              type="number"
              name="numberOfGuests"
              value={form.numberOfGuests}
              onChange={handleChange}
            />
          </Col>

        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>

        <Button
  color="primary"
  disabled={isInvalid}
  onClick={handleSave}
>
  Save Changes
</Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditReservationModal;